import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, map } from 'rxjs';
import { User } from '../models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _isLoggedIn = new BehaviorSubject<boolean>(false);
  isLoggedIn = this._isLoggedIn.asObservable();
  userLoggedIn: boolean = false;

  LOCAL_USER_KEY: string = 'VISUAL_TOOL_USER';
  user: User | null = null;

  constructor(
    private router: Router,
    private http: HttpClient,
    private loaderService: LoaderService
  ) {
    this.init();

    this.isLoggedIn.subscribe((logged_in) => {
      this.userLoggedIn = logged_in;
    });
  }

  init() {
    const cacheUser = localStorage.getItem(this.LOCAL_USER_KEY);
    if (cacheUser && cacheUser !== null && cacheUser !== 'null') {
      const user: User = JSON.parse(cacheUser);
      if (user.username && user.password) {
        this.user = user;
        this._isLoggedIn.next(true);
        return;
      }
    }

    this.user = null;
    this._isLoggedIn.next(false);
  }

  setUser = (user: User) => {
    localStorage.setItem(this.LOCAL_USER_KEY, JSON.stringify(user));
    this.init();
  };

  login(username: string, password: string) {
    return this.http.get('/v4/bulk-api/job/verifyUser', {
      headers: new HttpHeaders({
        userName: username,
        password
      })
    }).pipe(map((resp: any) => {
      if (resp && resp.result) {
        const resUser: User = {
          username: resp.result.userName,
          password: password,
          email: resp.result.email,
          appId: resp.result['X-APP-ID'],
          appKey: resp.result['X-APP-KEY']
        };
        this.setUser(resUser);
      }
    }));
  }

  forgotPassword(email: string) {
    return new Promise<any>((resolve, reject) => {
      setTimeout(() => {
        resolve({
          result: true,
        });
      }, 1000);
    });
  }

  resetPassword(email: string, password: string) {
    return new Promise<any>((resolve, reject) => {
      setTimeout(() => {
        resolve({
          result: true,
        });
      }, 1000);
    });
  }

  logout() {
    localStorage.removeItem(this.LOCAL_USER_KEY);
    this.loaderService.loaderSubject.next(false);
    this.init();
    this.router.navigate(['/login']);
  }
}
